let preferences: any[];
let showCookiesBanner: string | null;

function toggleIcon() {
    const $elIcon = $(this).find('.toggle_collapse_icon');
    if ($(this).hasClass('collapsed')) {
        $elIcon.empty().html('<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>');
    } else {
        $elIcon.empty().html('<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 13H5v-2h14v2z"/></svg>');
    }
}

function hideCookiesDetails() {
    bootstrap.Modal.getInstance(document.getElementById('cookies-modal')).hide();
}

function showCookiesDetails() {
    new bootstrap.Modal(document.getElementById('cookies-modal')).show();
    if (document.getElementById('close-cookies-details-layout')) {
        document.getElementById('close-cookies-details-layout').addEventListener('click', () => {
            hideCookiesDetails();
        });
    }
}

async function handleCookiesBanner() {
    if (showCookiesBanner !== 'false') {
        showCookiesDetails();
    }
    document.querySelectorAll('.manage-cookies').forEach((element) => {
        element.addEventListener('click', (e) => {
            e.preventDefault();
            showCookiesDetails();
        });
    });
}

function showPreferences() {
    (document.querySelector('#cookies-modal #accordion') as HTMLDivElement).classList.toggle('d-none');
}

function setCookie(cname: string, cvalue: string, exdays = 180) {
    document.cookie = `${cname}=;Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

function storePreferences(prefs: any) {
    $.each(prefs, (i, item) => {
        if (item.data_type) {
            delete item.data_type.head_script;
            delete item.data_type.body_script;
        }
    });
    localStorage.setItem('showCookiesBanner', 'false');
    setCookie('cookiesPreferences', JSON.stringify(preferences));
}

function getRequiredCookies() {
    const preferencesRequired: any[] = [];
    $('#cookies-modal #accordion .data_element').each(function () {
        if ($(this).find('.float-right i').length !== 0) {
            preferencesRequired.push({
                name: $(this).find('.data_type_name').html(),
                data_type_id: parseInt($(this).find('.data_type_name').attr('data_id'), 10),
            });
        }
    });
    return preferencesRequired;
}

async function acceptRequiredCookies() {
    preferences = getRequiredCookies();
    preferences = preferences.map((preference) => {
        preference.active = 1;
        return preference;
    });
    storePreferences(preferences);
}

function denyAll() {
    storePreferences([]);
    hideCookiesDetails();
    acceptRequiredCookies();
}

function getAllCookies() {
    preferences = [];
    $('#cookies-modal #accordion .data_element').each(function () {
        preferences.push({
            name: $(this).find('.data_type_name').html(),
            data_type_id: parseInt($(this).find('.data_type_name').attr('data_id'), 10),
        });
    });
    return preferences;
}

function getAcceptedCookies() {
    preferences = [];
    $('#cookies-modal #accordion .data_element').each(function () {
        const $input = $(this).find('input');
        if ($input.prop('checked')) {
            preferences.push({
                name: $(this).find('.data_type_name').html(),
                data_type_id: parseInt($(this).find('.data_type_name').attr('data_id'), 10),
            });
        }
    });
    getRequiredCookies().map((cookie) => (
        preferences.push(cookie)
    ));
    return preferences;
}

async function acceptAllCookies() {
    hideCookiesDetails();
    preferences = getAllCookies();
    preferences = preferences.map((preference) => {
        preference.active = 1;
        return preference;
    });
    storePreferences(preferences);
}

async function validate(e: Event) {
    e.preventDefault();
    preferences = getAcceptedCookies();
    preferences = preferences.map((preference) => {
        preference.active = 1;
        return preference;
    });
    storePreferences(preferences);
    hideCookiesDetails();
}

document.addEventListener('DOMContentLoaded', () => {
    showCookiesBanner = localStorage.getItem('showCookiesBanner');
    handleCookiesBanner();
    $('#cookies-modal').on('click', '#btn_settings_rgpd', showPreferences);
    $('#cookies-modal').on('click', '#accept-all', acceptAllCookies);
    $('#cookies-modal').on('click', '#deny-all', denyAll);
    $('#cookies-modal').on('submit', '#accordion form', validate);
    $('#cookies-modal').on('click', '.toggle_collapse', toggleIcon);
});
